import { CircularProgress } from "@mui/material";

export const Loading = () => {
  return (
    <CircularProgress
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
      }}
    />
  );
};
